module.exports = __webpack_public_path__ + "img/OGMA-PAS.efaf9e24.jpg";